<template>
    <div class="per-page-selection pull-right">
        Show
        <select name="select-per-page" @change="doVisible" v-model="tablePerPage">
            <option v-for="(amount, index) in amountsShown" :key="index" :value="amount.value">{{amount.text}}</option>
        </select>
        entries
    </div>
</template>
<script>
export default {
    props: {
        perPage: Number
    },
    data() {
        return {
            tablePerPage: this.perPage,
            amountsShown: [
                { text: '10', value: 10 },
                { text: '25', value: 25 },
                { text: '50', value: 50 },
                { text: '100', value: 100 }
            ],
        }
    },
    methods: {
        doVisible() {
            this.$events.fire('per-page', this.tablePerPage)
        }
    }
}
</script>
